import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import ReactToPrint from 'react-to-print';
import Button from '../../../../components/base/Button/Button.component';
import { printBukuInduk } from '../../../../utils/print.util';

function onClickPrint(header, content, footer) {
  printBukuInduk(header, content, footer);
}

class ComponentToPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journal: {},
    };
    this.onGetDetails = this.onGetDetails.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
  }

  // componentDidMount() {
  //   this.onGetDetails();
  // }

  async onGetDetails() {
    const { handleGetCashJournal, match } = this.props;
    const { id } = match.params;
    try {
      const payload = await handleGetCashJournal({ id });
      this.setState({
        journal: payload,
      });
    } catch (err) {
      // err action
    }
  }

  _onFormChange(event) {
    const { onChange } = this.props;
    onChange(event);
  }


  render() {
    const { journal } = this.state;
    return (

      <div>

        {/* <Button
          title="Cetak Ke Printer"
          onClick={() => {
            onClickPrint('detail-cash-journal__header',
              'detail-cash-journal__table',
              'detail-cash-journal__footer');
          }}
        /> */}
        <div id="divPrint" style={{ width: 800, border: '0px solid black' }}>
          <div className="identitas-k13__content">
            <div className="identitas-k13__header">
              <div className="identitas-k13__custom-form-row-square">
                <div className="identitas-k13__box--square2">
                  Image
                </div>
                <div className="identitas-k13__header-title">
                  <div className="identitas-k13__header-title--column">
                    {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                    KETERANGAN TENTANG DIRI PESERTA DIDIK
                  </div>
                </div>
              </div>
            </div>
          </div>

          <table className="identitas-k13__table">
            <tr>
              <td />
              <td>1. Nama Siswa</td>
              <td>: Gange</td>
            </tr>
            <tr>
              <td />
              <td>2. No. Induk Siswa</td>
              <td>: 0210</td>
            </tr>
            <tr>
              <td />
              <td>3. Tempat dan Tanggal Lahir</td>
              <td>: SMP KATOLIK RICCI</td>
            </tr>
            <tr>
              <td />
              <td>4. Jenis Kelamin</td>
              <td>: Laki-laki</td>
            </tr>
            <tr>
              <td />
              <td>5. Agama</td>
              <td>: </td>
            </tr>
            <tr>
              <td />
              <td>6. Status Anak</td>
              <td>: Anak Ke dan 1 bersaudara</td>
            </tr>
            <tr>
              <td />
              <td>7. Status Dalam Keluarga</td>
              <td>: Anak Kandung</td>
            </tr>
            <tr>
              <td />
              <td>8. Alamat Siswa</td>
              <td>: JL APA AJA</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp;&nbsp;Telepon</td>
              <td>:-</td>
            </tr>

            <tr>
              <td />
              <td>9. Diterima disekolah ini</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; a. Dikelas</td>
              <td>:VII</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; b. Semester</td>
              <td>:1</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; c. Tanggal</td>
              <td>:18-11-2019</td>
            </tr>

            <tr>
              <td />
              <td>10. Sekolah Asal</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; a. Nama Sekolah</td>
              <td>:VII</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; b. Alamat</td>
              <td>:1</td>
            </tr>
            <tr>
              <td />
              <td>11. Orang Tua</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; a. Nama Ayah</td>
              <td>:VII</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; b. Nama Ibu</td>
              <td>:1</td>
            </tr>

            <tr>
              <td />
              <td>12. Alamat Orang Tua</td>
              <td>: </td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; Telepon</td>
              <td>:VII</td>
            </tr>

            <tr>
              <td />
              <td>13. Pekerjaan Orangtua</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; a. Ayah</td>
              <td>:VII</td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; b. Ibu</td>
              <td>:1</td>
            </tr>

            <tr>
              <td />
              <td>14. Nama Wali</td>
              <td>: </td>
            </tr>
            <tr>
              <td />
              <td>15. Alamat Wali</td>
              <td>: </td>
            </tr>
            <tr>
              <td />
              <td>&nbsp; Telepon</td>
              <td>:VII</td>
            </tr>
            <tr>
              <td />
              <td>16. Pekerjaan Wali</td>
              <td>: </td>
            </tr>
          </table>

          <div className="identitas-k13__custom-form-row-square2">
            <div className="identitas-k13__box2--square2">
              Image
            </div>
            <div className="identitas-k13__footer-title">
              <div className="identitas-k13__footer-title--column">
                {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                Jakarta,
              </div>
              <div className="identitas-k13__footer-title--column">
                {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                Kepala Sekolah
              </div>
              <div className="identitas-k13__footer-title--column2">
                {/* <h1>{journal.isCredit === false ? 'BUKTI KAS KELUAR' : 'BUKTI KAS MASUK'}</h1> */}
                (&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;)
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
export default class IdentitasPortraitK13 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      journal: {},
    };
  }


  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="box">

                <div className="divContainter">
                  <div>
                    <ReactToPrint
                      trigger={() => <Button style={{ marginBottom: 10 }} block>Print</Button>}
                      content={() => this.componentRef}
                    />
                    <ComponentToPrint ref={el => (this.componentRef = el)} />
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    );
  }
}
IdentitasPortraitK13.propTypes = {
  handleGetCashJournal: PropTypes.func,
  match: PropTypes.object.isRequired,
};
IdentitasPortraitK13.defaultProps = {
  handleGetCashJournal: noop,
};
